<template>
  <RkTable :data="shareholderList" :loading="loading" :finished="finished">
    <RkTableColumn prop="holderName" label="股东名称" fixed align="left" :width="`${postcssPatch(120)}`">
      <template #default="{ row }">{{ $digitjs(row.holderName).isNull() }}</template>
    </RkTableColumn>
    <RkTableColumn prop="holdingNumber_OS" label="持股数量" :width="`${postcssPatch(90)}`">
      <template #default="{ row }">{{ $digitjs(row.holdingNumber_OS).convert() }}</template>
    </RkTableColumn>
    <RkTableColumn prop="holdingRatio" label="持股比例" :width="`${postcssPatch(90)}`">
      <template #default="{ row }">{{ $digitjs(row.holdingRatio).unit('%').rounded() }}</template>
    </RkTableColumn>
    <RkTableColumn prop="changeNumber_OS" label="变动股数" :width="`${postcssPatch(100)}`">
      <template #default="{ row }">
        <div :style="{ color: $digitjs(row.changeNumber_OS).color() }">
          {{ $digitjs(row.changeNumber_OS).prefix().convert() }}
        </div>
      </template>
    </RkTableColumn>
    <RkTableColumn prop="pubDate" label="发布日期" :width="`${postcssPatch(100)}`">
      <template #default="{ row }">{{ $digitjs(row.pubDate).isNull() }}</template>
    </RkTableColumn>
  </RkTable>
</template>

<script>
import { postcssPatch } from '@/utils/postcssPatch'

export default {
  data() {
    return {
      loading: false,
      finished: false,
      shareholderList: []
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    }
  },
  created() {
    this.getShareholderList()
  },
  methods: {
    postcssPatch,
    async getShareholderList() {
      this.loading = true
      const res = await this.$post(this.$api.f10.us + '/summary/major-shareholders', {
        symbol: this.symbol
      })
      const data = res.data ?? []
      this.shareholderList = data.sort((a, b) => b.holdingRatio - a.holdingRatio)
      this.finished = true
      this.loading = false
    }
  }
}
</script>
